import { ArrowRight, Crosshair } from "lucide-react";
import { TACTICAL_ITEMS, TACTICAL_BG } from "../../data/content";

export const FeaturedTactical = () => {
  return (
    <section id="tactical" data-testid="tactical-section" className="relative border-t border-white/10 overflow-hidden scroll-mt-20">
      <div className="absolute inset-0">
        <img src={TACTICAL_BG} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <Crosshair size={18} className="text-white" />
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">Core Specialty</span>
            </div>
            <h2 className="font-sans font-black uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl text-white leading-[0.95]">
              Tactical Equipment <span className="metal-text">Is Our Foundation</span>
            </h2>
            <p className="mt-6 max-w-2xl font-body text-neutral-300 text-base md:text-lg leading-relaxed">
              Atlas was built around tactical and defense equipment. It remains our specialty and the standard we hold
              across every category we support — sourced brand-neutral, to spec, and delivered on schedule.
            </p>
          </div>

          <div className="lg:col-span-5 border border-white/15 bg-[#0A0A0A]/70 backdrop-blur-sm p-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-5">Representative Items</p>
            <ul className="space-y-3">
              {TACTICAL_ITEMS.map((item) => (
                <li key={item} className="flex items-center gap-3 font-body text-white text-sm border-b border-white/10 pb-3 last:border-0 last:pb-0">
                  <span className="h-1.5 w-1.5 bg-white" />
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              data-testid="tactical-cta"
              className="group mt-7 w-full inline-flex items-center justify-center gap-2 bg-white text-black font-sans font-bold uppercase tracking-widest px-6 py-3.5 hover:bg-neutral-300 transition-colors"
            >
              Request a Quote <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
